import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TextAutomation,
    GetTextAutomation as TextAutomationQuery,
} from 'nutshell-graphql-types';

import GET_TEXT_AUTOMATIONS_FOR_STAGE from '../queries/get-text-automation.graphql';

export const useGetTextAutomation = (
    id?: string | null
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    textAutomation: TextAutomation | null | undefined;
} => {
    const {loading, data, error} = useQuery<TextAutomationQuery, Record<any, any>>(
        GET_TEXT_AUTOMATIONS_FOR_STAGE,
        {
            fetchPolicy: 'cache-and-network',
            variables: {id},
            skip: !id,
            notifyOnNetworkStatusChange: true,
        }
    );

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        textAutomation: data ? data.textAutomation : null,
    };
};
